export default __webpack_public_path__ + "static/media/fileUpload.184d50c2.jpg";